export type VisitTreatmentDetailsApiModel = {
  treatmentName: string;
  treatmentId: string;
  employeeName: string;
  price: string;
  isPriceInaccurate: boolean;
  isPriceVisible: boolean;
  durationInMinutes: number;
  isDurationVisible: boolean;
  isEmployeeSelected: boolean;
}
